//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useState, useContext } from "react";
import { Card, Col, Container, Row, Button, Form, InputGroup } from "react-bootstrap";
import Select from 'react-select';
import { UserDetailsActions } from "./userDetailsActions";
import { CandidatePageActions } from "../candidatePageActions";
import { Context } from "../common/context/Context";
import AlertMessage from "../common/alertMessages/alertMessages";
import ErrorAlertMessage from "../common/alertMessages/errorAlertMessage";
import { useLocation } from "react-router-dom";
import "./index.css";
import { useAccessTypes } from "../aAdminTabTeam2/hooksAndFunctions/customHooks/useAccessTypes";

const UserDetails = () => {
    const {
        isEnterpriseAdmin: isEnterpriseAdminType,
        clientPortalAdminType,
        candidatePortalAdminType,
    } = useAccessTypes()

    const { isClientPortalAdmin, hasA1Access, hasA2Access, hasA3Access } = clientPortalAdminType
    const { isCandidatePortalAdmin, hasSuperAdminAccess, hasAdminAccess, hasCoachAccess, hasCoachAdminAccess } = candidatePortalAdminType

    // console.log("isProdEnv", isProdEnv)

    const context = useContext(Context);
    const location = useLocation();
    const UserCoach = "Coach";
    const UserCoachAdmin = "Coach Admin"
    const [allUserData, setAllUserData] = useState();

    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [hoursList, setHoursList] = useState();
    const [cronofyServiceAccountName, setCronofyServiceAccountName] = useState();
    const [cronofyTime, setCronofyTime] = useState();
    const [weekDaysList, setWeekDaysList] = useState([]);
    const [createNewUserJson, setCreateNewUserJson] = useState({});

    const [userRoleList, setUserRoleList] = useState([]);
    const [languageList, setLanguageList] = useState([]);

    const [serviceOfficeList, setServiceOfficeList] = useState([]);
    const [serviceOffice, setServiceOffice] = useState("");
    const [userRoleServiceOfficeList, setUserRoleServiceOfficeList] = useState(null);

    const [countryCode, setCountryCode] = useState();
    const [userRoleServiceOffice, setUserRoleServiceOffice] = useState([]);

    const [language, setLanguage] = useState([]);
    const [timeZoneOptions, setTimeZoneOptions] = useState([]);
    const [timeZone, setTimeZone] = useState("");

    const [userRole, setUserRole] = useState("");
    const [clientUserRole, setClientUserRole] = useState("");

    const [weekDay, setWeekDay] = useState(null);
    const [activeEmail, setActiveEmail] = useState('');
    const [status, setStatus] = useState();
    const [cronofyServiceAccount, setCronofyServiceAccount] = useState();
    const [cronofyTimeZone, setCronofyTimeZone] = useState();
    const [userCountry, setUserCountry] = useState({});

    const [prefName, setPrefName] = useState()
    const [prefNumber, setPrefNumber] = useState();
    const [affEmail, setAffEmail] = useState();

    const [graphData, setGraphData] = useState({
        id: '',
        firstName: '',
        lastName: '',
        preferredName: '',
        email: '',
        preferredNumber: '',
        affiliateEmail: ''
    });
    const [update, setUpdate] = useState({
        timeZone: false,
        country: false,
        appLanguage: false,
        serviceOffice: false,
        status: false,
        userRole: false,
        userServiceOffice: false,
        userRoleSelectedServiceOffice: false,
        userCountry: false,
        cronofyTimeZone: false,
        serviceAccountName: false,
        startTime: false,
        endTime: false,
        workingDaysList: false,
        schedulingAvailability: false
    });
    const [workingHours, setWorkingHours] = useState({
        startHour: '',
        endHour: '',
        availableDays: []
    });
    const [userProfileData, setUserProfileData] = useState({
        bio: '',
        expertise: '',
        linkedInID: '',
        twitterID: '',
        language: ''
    });
    const [alertForSearch, setAlertForSearch] = useState({
        message: "",
        type: "",
        showAlert: false
    })
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })
    const [userDetails, setUserDetails] = useState({
        id: '',
        firstName: '',
        lastName: '',
        preferredName: '',
        email: '',
        preferredNumber: '',
        affiliateEmail: ''
    });

    /**@@@@@@@@@@@@@ Ganesh @@@@@@@@@@@@@@@@@@ */
    /**role adding logic */
    const [isEnterpriseAdmin, setIsEnterpriseAdmin] = useState(false)
    const [candidatePortalRoleList, setCandidatePortalRoleList] = useState([])
    const [clientPortalRoleList, setClientPortalRoleList] = useState([])

    // console.log("candidatePortalRoleList", candidatePortalRoleList)

    const ADMIN = 'Admin';
    const SUPER_ADMIN = 'Super Admin';
    const ENPTERPRISE_ADMIN = 'Enterprise Admin';
    const COACH = 'Coach';
    const COACH_ADMIN = 'Coach Admin';

    useEffect(() => {
        if (!!userRoleList && userRoleList.length) {

            let clientRoles = [];
            let candidateRoles = [];
            //const regex = /A1|A2|A3/;
            userRoleList.forEach((item) => {
                if (item?.groupName === 'G3') {
                    clientRoles.push(item)
                } else if (item?.groupName === 'G2') {
                    candidateRoles.push(item)
                }
            })
            setCandidatePortalRoleList(candidateRoles)
            setClientPortalRoleList(clientRoles)
        }
    }, [userRoleList])

    /**disabling logic for roles */
    const [disabledCandidatePortalRole, setDisabledCandidatePortalRole] = useState(false)
    const [disabledClientPortalRole, setDisabledClientPortalRole] = useState(false)
    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            /**clearing all selected items */
            //setCandidatePortalRoleList([])
            //setClientPortalRoleList([])
            setUserRole('');
            setClientUserRole('');

            /**disabled state */
            setDisabledCandidatePortalRole(true)
            setDisabledClientPortalRole(true)
        } else {
            // setDisabledCandidatePortalRole(false)
            // setDisabledClientPortalRole(false)

            /**access control for candidate portal */
            if (!!isEnterpriseAdminType) {
                setDisabledCandidatePortalRole(false)
            } else {
                if (!!hasSuperAdminAccess) {
                    setDisabledCandidatePortalRole(false)
                } else {
                    setDisabledCandidatePortalRole(true)
                }
            }

            /**access control for client portal */
            if (!!isEnterpriseAdminType) {
                setDisabledClientPortalRole(false)
            } else {
                if (!!hasA1Access) {
                    setDisabledClientPortalRole(false)
                } else {
                    setDisabledClientPortalRole(true)
                }
            }
        }
    }, [isEnterpriseAdmin, isEnterpriseAdminType, clientPortalAdminType, candidatePortalAdminType])

    //---- FUNCTIONS -----//
    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }
    const fetchUserDetails = async () => {
        setGraphData({
            firstName: '',
            lastName: '',
            preferredName: '',
            email: '',
            preferredNumber: '',
            affiliateEmail: ''
        });

        let refAlert = JSON.parse(JSON.stringify(alertForSearch));

        await UserDetailsActions.GetUserDetails(activeEmail).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let graphApiData = res?.data;
                    let userDetails = {
                        id: graphApiData?.id,
                        firstName: graphApiData?.givenName,
                        lastName: graphApiData?.surname,
                        preferredName: graphApiData?.displayName,
                        email: graphApiData?.mail,
                        preferredNumber: graphApiData?.primaryContactNo,
                        affiliateEmail: graphApiData?.affiliateEmailAddress,
                    }
                    setGraphData(userDetails);
                    setAffEmail(graphApiData?.affiliateEmailAddress);
                    setPrefName(graphApiData?.username);
                    setPrefNumber(graphApiData?.primaryContactNo);
                }
                else if (res.status === 404) {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = fetchCreateNewUserLabel('CreateNewUser.SearchErrorMessage');
                    setAlertForSearch(refAlert)
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchUserDetailsByStaffId = async (staffId) => {

        let refWorkingHours = JSON.parse(JSON.stringify(workingHours));



        await UserDetailsActions.GetUserDetailsByStaffId(staffId).then(
            (res) => {
                if (res.status === 200) {
                    let userDetailsData = res?.data;
                    let userDetails = {
                        id: userDetailsData?.id,
                        firstName: userDetailsData?.firstName,
                        lastName: userDetailsData?.lastName,
                        preferredName: userDetailsData?.username ? userDetailsData?.username : userDetailsData?.firstName,
                        email: userDetailsData?.emailAddress,
                        preferredNumber: userDetailsData?.primaryContactNo,
                        affiliateEmail: userDetailsData?.affiliateEmailAddress
                    }
                    setUserDetails(userDetails);
                    setAffEmail(userDetailsData?.affiliateEmailAddress);
                    setPrefName(userDetailsData?.username);
                    setPrefNumber(userDetailsData?.primaryContactNo);

                    let userProfile = {
                        bio: userDetailsData?.bio,
                        expertise: userDetailsData?.expertise,
                        linkedInID: userDetailsData?.socialIdDetails?.split(",")[0],
                        twitterID: userDetailsData?.socialIdDetails?.split(",")[1],
                        language: userDetailsData?.language
                    }
                    fetchLanguage(res?.data?.countryCode)
                    setUserProfileData(userProfile)
                    setAllUserData(res?.data)
                    fetchCronofyTimeZone(res?.data?.countryCode);

                    /**set userRole Empty if roleobject has A1/A2/A3 roles */
                    const clientPortalAdminRegEx = /f49f7717-5bae-4ba4-b069-1fa1502ee88e|82511c17-b73c-4b9f-b0b2-2794c8425ca9|94564334-a8fb-4431-a758-9ee95ddb9908/

                    const roleIdFromAPI = res?.data?.role?.role?.roleId
                    if (!!roleIdFromAPI) {
                        if (!!roleIdFromAPI && roleIdFromAPI?.search(clientPortalAdminRegEx) !== -1) {
                            setUserRole("")
                        } else {
                            setUserRole(res?.data?.role?.role?.roleId);
                        }
                    } else {
                        setUserRole("")
                    }

                    setClientUserRole(res?.data?.clientPortalAdminRoleId);
                    setIsEnterpriseAdmin(res?.data?.isEnterpriseAdmin);
                    getServiceOffice(res?.data?.countryCode);

                    let serviceOfficeLists = res?.data && res?.data?.role?.serviceOffices;
                    serviceOfficeLists = serviceOfficeLists && serviceOfficeLists.map((x) => ({
                        label: x.rightOfficeName,
                        value: {
                            rightOfficeName: x.rightOfficeName,
                            rightOfficeId: x.rightOfficeId,
                            countryCode: x.countryCode,
                        }
                    }))
                    setServiceOffice(serviceOfficeLists)

                    let existingUserServiceOffice = []

                    res?.data?.role?.serviceOffices?.map((item) => {
                        existingUserServiceOffice.push(
                            {
                                label: item.rightOfficeName,
                                value: item.rightOfficeName,
                                countryCode: item.countryCode,
                                rightOfficeId: item.rightOfficeId
                            }
                        )
                    })

                    let uniqueCountryList = [];
                    let existingCountryList = []

                    existingUserServiceOffice.map((item) => {
                        context.userRoleCountryList.map((item1) => {
                            if (item.countryCode.toLowerCase() === item1.value.toLowerCase()) {

                                if (!uniqueCountryList.includes(item1.value)) {
                                    uniqueCountryList.push(item1.value);
                                    existingCountryList.push(
                                        {
                                            label: item1.label,
                                            value: item1.value,
                                        }
                                    )
                                }
                            }
                        })
                    })
                    setUserCountry(existingCountryList);
                    setUserRoleServiceOffice(existingUserServiceOffice);

                    let resData = res?.data;

                    let weekDaysListsHardCoded = [];
                    let weekDays = [
                        {
                            id: 0,
                            label: 'Monday'
                        },
                        {
                            id: 1,
                            label: 'Tuesday'
                        },
                        {
                            id: 2,
                            label: 'Wednesday'
                        },
                        {
                            id: 3,
                            label: 'Thursday'
                        },
                        {
                            id: 4,
                            label: 'Friday'
                        },
                        {
                            id: 5,
                            label: 'Saturday'
                        },
                        {
                            id: 6,
                            label: 'Sunday'
                        }
                    ]
                    weekDaysListsHardCoded.push(weekDays);
                    let weekDaysListData = weekDaysListsHardCoded[0];
                    let weekDaysOptions = weekDaysListData?.map((item) => ({ label: item?.label, value: item?.id }))

                    refWorkingHours.startHour = resData?.schedulingAvailability?.weekly_periods[0]?.start_time;
                    refWorkingHours.endHour = resData?.schedulingAvailability?.weekly_periods[0]?.end_time;

                    let daysArray = resData?.schedulingAvailability?.weekly_periods?.map((x) => x.day);
                    daysArray = weekDaysOptions && weekDaysOptions.length > 0 && weekDaysOptions?.filter(function (el) {
                        return daysArray.indexOf(el.label.toLowerCase()) >= 0;
                    });
                    refWorkingHours.availableDays = daysArray;
                    setWorkingHours(refWorkingHours);
                    setWeekDay(daysArray);
                }
            }
        )
    }
    const getUserServiceOffice = async (countryCode) => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await CandidatePageActions.GetServiceOffice(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {

                    let serviceOfficesArray = []
                    res?.data.map((item) => {
                        serviceOfficesArray.push({
                            label: item?.rightOfficeName,
                            value: item?.rightOfficeName,
                            countryCode: item?.countryCode,
                            rightOfficeId: item?.rightOfficeId
                        })
                    })
                    setUserRoleServiceOfficeList(serviceOfficesArray)

                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const getServiceOffice = async (countryCode) => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await CandidatePageActions.GetServiceOffice(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setServiceOfficeList(res.data && res.data)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const fetchUserRoles = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        UserDetailsActions.GetUserRole().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setUserRoleList(res?.data);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const fetchLanguage = async (country) => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        UserDetailsActions.GetLanguage(country).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setLanguageList(res?.data);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const fetchCreateNewUserJson = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        await UserDetailsActions.GetCreateNewUserJSON().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setCreateNewUserJson(JSON.parse(JSON.stringify(res?.data)));
                    let daysList = res?.data?.Properties?.WeekDaysList;
                    let hours = res?.data?.Properties?.HoursList;
                    getWeekDaysList(daysList && daysList)
                    getHoursList(hours && hours)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const fetchCreateNewUserLabel = (key) => {
        let refJsonContent = JSON.parse(JSON.stringify(createNewUserJson));
        let label = "";

        refJsonContent?.Properties?.Labels?.map((x) => {
            if (x.Key === key) {
                label = x.Phrase;
            }
        });

        return label;
    };
    const fetchTimeZone = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await UserDetailsActions.GetTimeZone(allUserData?.applicationLanguageCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let arrTimezone = [];
                    const data = res?.data
                    !!data && data.filter((item) => {
                        if (item.key === "timezone") {
                            item?.items?.map((tz) => {
                                arrTimezone.push({
                                    "name": tz.title,
                                    "value": tz.id
                                })
                            });
                        }
                    });

                    setTimeZoneOptions(arrTimezone)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const fetchCronofyServiceAccount = async () => {
        await UserDetailsActions.GetCronofyServiceAccount().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setCronofyServiceAccount(res?.data)
                }
                else {
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchCronofyTimeZone = async (countryCode) => {
        await UserDetailsActions.GetCronofyTimeZone(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {

                    setCronofyTimeZone(res?.data);

                } else {
                    window.scrollTo(0, 0)
                }
            },
            (err) => {
                console.log(err)
            }
        );
    }

    const getHoursList = async (hoursLists) => {

        let hoursListsHardCoded = [];
        let hours = [
            {
                id: 0,
                label: '00:00'
            },
            {
                id: 1,
                label: '01:00'
            },
            {
                id: 2,
                label: '02:00'
            },
            {
                id: 3,
                label: '03:00'
            },
            {
                id: 4,
                label: '04:00'
            },
            {
                id: 5,
                label: '05:00'
            },
            {
                id: 6,
                label: '06:00'
            },
            {
                id: 0,
                label: '07:00'
            },
            {
                id: 1,
                label: '08:00'
            },
            {
                id: 2,
                label: '09:00'
            },
            {
                id: 3,
                label: '10:00'
            },
            {
                id: 4,
                label: '11:00'
            },
            {
                id: 5,
                label: '12:00'
            },
            {
                id: 6,
                label: '13:00'
            },
            {
                id: 0,
                label: '14:00'
            },
            {
                id: 1,
                label: '15:00'
            },
            {
                id: 2,
                label: '16:00'
            },
            {
                id: 3,
                label: '17:00'
            },
            {
                id: 4,
                label: '18:00'
            },
            {
                id: 5,
                label: '19:00'
            },
            {
                id: 6,
                label: '20:00'
            },
            {
                id: 0,
                label: '21:00'
            },
            {
                id: 1,
                label: '22:00'
            },
            {
                id: 2,
                label: '23:00'
            }
        ]
        hoursListsHardCoded.push(hours);
        let hoursListData = hoursLists && hoursLists.length > 0 ? hoursLists : hoursListsHardCoded;
        let hoursOptions = hoursListData?.map((item) => ({ label: item?.label, value: item?.id }))
        setHoursList([...hoursOptions]);
    }

    const getWeekDaysList = async (weekDaysLists) => {

        let selectAllLabel = fetchCreateNewUserLabel('CreateNewUser.SelectAllLabel');
        let selectAllValue = fetchCreateNewUserLabel('CreateNewUser.SelectAllValue');
        let selectAllOption = { label: selectAllLabel, value: selectAllValue }
        let weekDaysListsHardCoded = [];
        let weekDays = [
            {
                id: 0,
                label: 'Monday'
            },
            {
                id: 1,
                label: 'Tuesday'
            },
            {
                id: 2,
                label: 'Wednesday'
            },
            {
                id: 3,
                label: 'Thursday'
            },
            {
                id: 4,
                label: 'Friday'
            },
            {
                id: 5,
                label: 'Saturday'
            },
            {
                id: 6,
                label: 'Sunday'
            }
        ]
        weekDaysListsHardCoded.push(weekDays);
        let weekDaysListData = weekDaysLists && weekDaysLists.length > 0 ? weekDaysLists : weekDaysListsHardCoded;
        let weekDaysOptions = weekDaysListData?.map((item) => ({ label: item?.label, value: item?.id }))
        setWeekDaysList([selectAllOption, ...weekDaysOptions]);
    }

    const handleCountryChange = (e) => {

        let newUserCounty = e.target.value;
        if (newUserCounty?.length > 0) {
            getServiceOffice(newUserCounty);
            setCountryCode(newUserCounty);
        }
        else {
            setServiceOfficeList([]);
        }
    }

    const handleUserCountryChange = (value) => {
        if (value?.length > 0) {
            let selectedCountries = value.map((item) => item.value).join(',');
            getUserServiceOffice(selectedCountries);
        }
        else {
            setUserRoleServiceOfficeList([]);
        }
        setUserCountry(value);
    }

    const handleWeekDaysChange = (value) => {
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.workingDaysList = true;
        setUpdate(refUpdate)
        let refWorkingHours = JSON.parse(JSON.stringify(workingHours));
        refWorkingHours.availableDays = value;
        setWorkingHours(refWorkingHours);
        setWeekDay(value);
    }


    const handleServiceOfficeChange = (e) => {
        let office = e.target.value;
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.serviceOffice = true;
        setUpdate(refUpdate);
        setServiceOffice(office);
    }

    const handleUserServiceOfficeChange = (value) => {
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.userRoleSelectedServiceOffice = true;
        setUpdate(refUpdate);

        let newUserServiceOffice = [];
        value.map((x) => {
            newUserServiceOffice.push({
                label: x?.label,
                value: x?.value,
                countryCode: x?.countryCode,
                rightOfficeId: x?.rightOfficeId
            })
        })
        setUserRoleServiceOffice(newUserServiceOffice);
    }

    const [alert, setAlert] = useState({
        message: "",
        type: "",
        showAlert: false
    })

    const showModal = () => {
        let refAlert = JSON.parse(JSON.stringify(alert));
        refAlert.showAlert = false;
        setAlert(refAlert)
    }

    const fetchServiceOfficesForMultiSelect = (serviceOffices) => {
        let serviceOfficeOptions = serviceOffices?.map((item) => ({ label: item?.rightOfficeName, value: JSON.parse(JSON.stringify(item)) }))
        return serviceOfficeOptions;
    };


    const fetchUserRole = (roleIds) => {
        let rolesList = userRoleList?.filter((x) => x.roleId == roleIds);
        rolesList = rolesList[0]?.role;
        return rolesList;
    }

    const fetchUserRoleId = (role) => {
        let rolesList = userRoleList?.filter((x) => x.role == role);
        rolesList = rolesList[0]?.roleId;
        return rolesList;
    }

    const fetchAvailability = () => {
        if (fetchUserRole(userRole) === ADMIN || fetchUserRole(userRole) === SUPER_ADMIN || fetchUserRole(userRole) === ENPTERPRISE_ADMIN)
            return;
        let weeklyPeriods = !!weekDay && weekDay.map((item) => ({
            day: item?.label.toLowerCase(),
            start_time: document && document.getElementById("startTime")?.value || "",
            //start_time: startTime,
            end_time: document && document.getElementById("endTime")?.value || ""
            //end_time: endTime
        }));
        return weeklyPeriods;
    }


    /**role object for Update API payload */
    const [roleObjForPayload, setRoleObjForPayload] = useState({
        Roleid: '',
        Role: '',
    })

    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            setRoleObjForPayload({
                Roleid: fetchUserRoleId(ENPTERPRISE_ADMIN) || "",
                Role: ENPTERPRISE_ADMIN || "",
            })
        } else {
            if (!!userRole) {
                setRoleObjForPayload({
                    Roleid: userRole || "",
                    Role: fetchUserRole(userRole) || ""
                })
            } else {
                /**RoleId is mandatory so if empty pass either clientPortalRoleId */
                setRoleObjForPayload({
                    Roleid: clientUserRole || "",
                    Role: fetchUserRole(clientUserRole) || "",
                })
            }
        }
    }, [isEnterpriseAdmin, userRole, clientUserRole])


    const updateUserDetails = async (data) => {
        let refAlert = JSON.parse(JSON.stringify(alert));
        let { staffId } = location && location.state;
        let refUpdate = JSON.parse(JSON.stringify(update));
        let office = serviceOffice && JSON.parse(JSON.stringify(serviceOffice));

        // console.log("vvvvv", userRoleServiceOffice)
        // let serviceOfficesArray = [];
        const serviceOfficesArray = !!userRoleServiceOffice && userRoleServiceOffice.map((item) => {
            return {
                "ServiceOfficeId": item?.rightOfficeId || '',
                "CountryCode": item?.countryCode || '',
                "ServiceOfficeName": item?.value || ''
            }
        })

        let payloadWithoutCoach = {
            "ActiveDirectoryId": process.env.REACT_APP_AD_CLIENT_ID,
            "StaffId": staffId && staffId,
            "FirstName": allUserData?.firstName,
            "LastName": allUserData?.lastName,
            "Username": prefName,
            "AffiliateEmailAddress": affEmail,
            "CountryCode": allUserData?.countryCode,
            "EmailAddress": allUserData?.emailAddress,
            "timeZone": !refUpdate.timeZone ? allUserData?.timeZone : timeZone,
            "ContactNo": document && document.getElementById("preferredNumber").value,
            "ApplicationLanguage": !refUpdate.appLanguage ? allUserData?.applicationLanguageCode : language,
            "ServiceOfficeId": !refUpdate.serviceOffice ? allUserData?.rightOfficeId : office?.rightOfficeId,
            "ServiceOfficeName": !refUpdate.serviceOffice ? allUserData?.rightOffice : office?.rightOfficeName,
            "IsActive": !refUpdate.status ? allUserData?.isActive : status == 1 ? "true" : status == 0 ? "false" : '',
            "ServiceAccountId": !refUpdate.serviceAccountName ? allUserData?.serviceAccountId : cronofyServiceAccountName,
            "IsEnterpriseAdmin": isEnterpriseAdmin,
            "ClientPortalAdminRoleId": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : !!clientUserRole ? clientUserRole : "",
            "Role": {
                // //"Roleid": !refUpdate.userRole ? allUserData?.role?.role?.roleId : userRole,
                // "Roleid": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : userRole === 'Select User Role' ? '' : userRole,
                // //"Role": !refUpdate.userRole ? allUserData?.role?.role?.role : fetchUserRole(userRole),
                // "Role": isEnterpriseAdmin ? ENPTERPRISE_ADMIN : fetchUserRole(userRole),
                ...roleObjForPayload,
                "serviceOffices": serviceOfficesArray || []
            }
        }

        let payloadWithCoach = {
            "ActiveDirectoryId": process.env.REACT_APP_AD_CLIENT_ID,
            "StaffId": staffId && staffId,
            "FirstName": allUserData?.firstName,
            "LastName": allUserData?.lastName,
            "Username": prefName,
            "CountryCode": allUserData?.countryCode,
            "EmailAddress": allUserData?.emailAddress,
            "AffiliateEmailAddress": affEmail,
            "timeZone": !refUpdate.timeZone ? allUserData?.timeZone : timeZone,
            "ContactNo": document && document.getElementById("preferredNumber").value,
            "ApplicationLanguage": !refUpdate.appLanguage ? allUserData?.applicationLanguageCode : language,
            "ServiceOfficeId": !refUpdate.serviceOffice ? allUserData?.rightOfficeId : office?.rightOfficeId,
            "ServiceOfficeName": !refUpdate.serviceOffice ? allUserData?.rightOffice : office?.rightOfficeName,
            "IsActive": !refUpdate.status ? allUserData?.isActive : status == 1 ? "true" : status == 0 ? "false" : '',
            "Bio": userProfileData?.bio === undefined ? " " : userProfileData?.bio,
            "Expertise": userProfileData?.expertise === undefined ? " " : userProfileData?.expertise,
            "Language": userProfileData?.userRoleLanguage === undefined ? " " : userProfileData?.userRoleLanguage,
            "SocialIdDetails": userProfileData?.linkedInID && userProfileData?.twitterID,
            "ServiceAccountId": !refUpdate.serviceAccountName ? allUserData?.serviceAccountId : cronofyServiceAccountName,
            "IsEnterpriseAdmin": isEnterpriseAdmin,
            "ClientPortalAdminRoleId": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : !!clientUserRole ? clientUserRole : "",
            "Role": {
                // //"Roleid": !refUpdate.userRole ? allUserData?.role?.role?.roleId : userRole,
                // "Roleid": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : userRole === 'Select User Role' ? '' : userRole,
                // //"Role": !refUpdate.userRole ? allUserData?.role?.role?.role : fetchUserRole(userRole),
                // "Role": isEnterpriseAdmin ? ENPTERPRISE_ADMIN : fetchUserRole(userRole),
                ...roleObjForPayload,
                "serviceOffices": serviceOfficesArray || []
            },
            "schedulingAvailability": {
                "tzid": !refUpdate.cronofyTimeZone ? allUserData?.ianaTimeZoneIdentifier : cronofyTime,
                "weekly_periods": fetchAvailability(),
            }
        }
        // let payload = (userRole == "2d9917fe-7720-ed11-bd6e-501ac574d42d" || userRole == "2e9917fe-7720-ed11-bd6e-501ac574d42d") ? payloadWithCoach : payloadWithoutCoach;

        let payload = {}

        if (fetchUserRole(userRole) === COACH || fetchUserRole(userRole) === COACH_ADMIN) {
            payload = payloadWithCoach
        } else {
            payload = payloadWithoutCoach
        }
        // let payload = (fetchUserRole(userRole) == COACH || fetchUserRole(userRole) == COACH_ADMIN) ? payloadWithCoach : payloadWithoutCoach;

        UserDetailsActions.UpdateUserDetails(payload)
            .then(
                (res) => {
                    if (res.status === 202 || res.status === 200) {
                        refAlert.showAlert = true;
                        refAlert.type = "success";
                        refAlert.message = "Save Successful";
                    }
                    else if (res.status === 400 && res.data == "Please select all Mandatory values") {
                        refAlert.showAlert = true;
                        refAlert.type = "danger";
                        refAlert.message = "Please select all Mandatory values";
                    }
                    else if (res.status === 500) {
                        refAlert.showAlert = true;
                        refAlert.type = "danger";
                        refAlert.message = "Unable to save. Some error has occurred. Please try again later";
                    }
                    setAlert(refAlert);
                },
                (err) => {
                    console.log(err);
                }
            );

    }

    const deleteUserDetails = () => {
        let { staffId } = location && location.state;
        fetchUserDetailsByStaffId(staffId);
    }

    const updateTimeZone = (e) => {
        let refUpdate = JSON.parse(JSON.stringify(update))
        refUpdate.timeZone = true;
        setUpdate(refUpdate);
        setTimeZone(e.target.value)
    }

    const handleApplicationLanguage = (e) => {
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.appLanguage = true;
        setUpdate(refUpdate)
        setLanguage(e.target.value)
    }

    const handleStatusChange = (e) => {
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.status = true;
        setUpdate(refUpdate);
        setStatus(e.target.value);
    }

    const handleUserRole = (e) => {
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.userRole = true;
        setUpdate(refUpdate)
        setUserRole(e.target.value)
    }

    const handleCronofyTime = (e) => {
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.cronofyTimeZone = true;
        setUpdate(refUpdate);
        setCronofyTime(e.target.value);
    }

    const handleCronofyServiceAccountName = (e) => {
        let refUpdate = JSON.parse(JSON.stringify(update));
        refUpdate.serviceAccountName = true;
        setUpdate(refUpdate);
        setCronofyServiceAccountName(e.target.value)
    }

    //---- USE EFFECT ----//
    useEffect(() => {
        fetchCreateNewUserJson();
        fetchTimeZone();
        fetchUserRoles();
        fetchUserDetails();
    }, [userRole, allUserData]);

    useEffect(() => {
        let { staffId } = location && location.state;
        fetchUserDetailsByStaffId(staffId && staffId);
        fetchCronofyServiceAccount();
    }, []);

    useEffect(() => {
        fetchCronofyTimeZone(countryCode);
    }, [countryCode]);


    return (
        <React.Fragment>
            <Col lg='12'>
                <Container fluid className="p-0">
                    {errorAlert?.showAlert &&
                        <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
                    }
                    <h1 className="h3 m-3"> {fetchCreateNewUserLabel('CreateNewUser.UserDetails')}</h1>
                    <Row>
                        <Card>
                            <Card.Body>
                                <Card.Title>{fetchCreateNewUserLabel('CreateNewUser.UserDetails')}</Card.Title>
                                <Form>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.FirstName')}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    id='firstName'
                                                    name="firstName"
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.FirstName')}
                                                    value={userDetails?.firstName}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.LastName')}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="lastName"
                                                    id='lastName'
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.LastName')}
                                                    value={userDetails?.lastName}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.PreferredName')}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="preferredName"
                                                    id='preferredName'
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.PreferredName')}
                                                    value={prefName}
                                                    onChange={(e) => setPrefName(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.Email')}</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    id='email'
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.Email')}
                                                    value={userDetails?.email} disabled />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.AffiliateEmailAddress')}</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="affiliateEmail"
                                                    id='affiliateEmail'
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.AffiliateEmailAddress')}
                                                    value={affEmail}
                                                    onChange={(e) => setAffEmail(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.PreferredNumber')}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="preferredNumber"
                                                    id='preferredNumber'
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.PreferredNumber')}
                                                    onChange={(e) => setPrefNumber(e.target.value)}
                                                    value={prefNumber}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">{fetchCreateNewUserLabel('CreateNewUser.TimeZone')}</Form.Label>
                                                <Form.Select
                                                    aria-label="Timezone Select"
                                                    id="timeZone"
                                                    name="timeZone"
                                                    onChange={(e) => updateTimeZone(e)}
                                                >
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectTimeZone')}</option>
                                                    {timeZoneOptions && timeZoneOptions.length > 0 && timeZoneOptions.map((item) => (
                                                        <option
                                                            selected={allUserData?.timeZone == item?.value}
                                                            value={item?.value}
                                                        >
                                                            {item?.name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">{fetchCreateNewUserLabel('CreateNewUser.Country')}</Form.Label>
                                                <Form.Select
                                                    aria-label="Country Select"
                                                    id="country"
                                                    name="country"
                                                    onChange={(e) => handleCountryChange(e)}
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.Country')}
                                                >
                                                    {context.countryList && context.countryList.length > 0 && context.countryList.map((item) => (
                                                        <option
                                                            selected={allUserData && allUserData?.countryCode == item?.standardCodeValue}
                                                            value={item?.standardCodeValue}
                                                        >
                                                            {item?.title}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">{fetchCreateNewUserLabel('CreateNewUser.ApplicationLanguage')}</Form.Label>
                                                <Form.Select
                                                    aria-label="Language Select"
                                                    id="language"
                                                    name="language"
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.SelectLanguage')}
                                                    onChange={(e) =>
                                                        handleApplicationLanguage(e)
                                                    }
                                                >

                                                    {languageList && languageList.length > 0 && languageList?.map((item) => (
                                                        <option
                                                            selected={allUserData && allUserData?.applicationLanguageCode == item?.localeName}
                                                            value={item?.localeName}
                                                        >
                                                            {item?.localeName}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">{fetchCreateNewUserLabel('CreateNewUser.ServiceOffice')}</Form.Label>
                                                <Form.Select
                                                    aria-label="Service Office Select"
                                                    id="serviceOffice"
                                                    name="serviceOffice"
                                                    onChange={(e) => handleServiceOfficeChange(e)}
                                                >
                                                    {serviceOfficeList && serviceOfficeList.length > 0 && serviceOfficeList?.map((item) => (
                                                        <option
                                                            selected={allUserData?.rightOfficeId == item?.rightOfficeId}
                                                            value={JSON.stringify(item)}
                                                        >
                                                            {item?.rightOfficeName}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.Status')}</Form.Label>
                                                <Form.Select
                                                    name="status"
                                                    aria-label="Status Select"
                                                    id='status'
                                                    onChange={(e) => handleStatusChange(e)}
                                                >
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectStatus')}</option>
                                                    <option value='1' selected={allUserData?.isActive ? true : false}>{fetchCreateNewUserLabel('CreateNewUser.Status.Active')}</option>
                                                    <option value='0' selected={allUserData?.isActive ? false : true}>{fetchCreateNewUserLabel('CreateNewUser.Status.InActive')}</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                            <Card.Body>
                                <Card.Title>{fetchCreateNewUserLabel('CreateNewUser.UserRole')}</Card.Title>
                                <Form>
                                    {/**@@@@@@@@@@@@@@@@@@@@@@@@@@@ */}
                                    {/**changes by Ganesh */}
                                    <Row>
                                        {/* <Col md={1}> */}
                                        {/**need API integration */}
                                        <Form.Group className="mb-3">
                                            <Row className='mt-3'>

                                                <Col sm={11} className='text-left'>
                                                    <Form.Check
                                                        name='isEnterpriseAdmin'
                                                        checked={isEnterpriseAdmin}
                                                        type="checkbox"
                                                        onChange={(data) => {
                                                            setIsEnterpriseAdmin(data.target.checked);
                                                        }}
                                                        aria-label="isEnterpriseAdmin check"
                                                        label={ENPTERPRISE_ADMIN}
                                                        className="control-label"
                                                        disabled={!isEnterpriseAdminType}
                                                    />
                                                </Col>
                                                {/* <Col sm={11} className='text-left'>
                                                    <Form.Label className="control-label"> Enterprise Admin</Form.Label>
                                                </Col> */}

                                            </Row>
                                        </Form.Group>
                                        {/* </Col> */}
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            {/**need API integration */}
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">Candidate Portal Role</Form.Label>
                                                <Form.Select
                                                    aria-label="candidatePortalRole Select"
                                                    id="candidatePortalRole"
                                                    name="candidatePortalRole"
                                                    value={userRole}
                                                    /**upon api integration will check handle user role */
                                                    onChange={(e) => {
                                                        setUserRole(e.target.value)
                                                    }}
                                                    disabled={
                                                        !!disabledCandidatePortalRole
                                                    }
                                                >
                                                    <option
                                                        value=""
                                                    >{fetchCreateNewUserLabel("CreateNewUser.SelectUserRole")}</option>
                                                    {candidatePortalRoleList && candidatePortalRoleList.length > 0 && candidatePortalRoleList?.map((item) => (
                                                        <option
                                                            selected={
                                                                allUserData && allUserData?.role?.role?.roleId == item?.roleId
                                                            }
                                                            value={item?.roleId}
                                                        >
                                                            {item?.role}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            {/**need API integration */}
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">Client Portal Role</Form.Label>
                                                <Form.Select
                                                    aria-label="clientPortalRole Select"
                                                    id="clientPortalRole"
                                                    name="clientPortalRole"
                                                    value={clientUserRole}
                                                    onChange={(e) => setClientUserRole(e.target.value)}
                                                    disabled={
                                                        !!disabledClientPortalRole
                                                    }

                                                >
                                                    <option
                                                        value=""
                                                    >{fetchCreateNewUserLabel("CreateNewUser.SelectUserRole")}</option>
                                                    {clientPortalRoleList && clientPortalRoleList.length > 0 && clientPortalRoleList?.map((item) => (
                                                        <option
                                                            selected={
                                                                allUserData && allUserData?.role?.role?.roleId == item?.roleId
                                                            }
                                                            value={item?.roleId}>
                                                            {item?.role}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/**@@@@@@@@@@@@@@@@@@@@@@@@@@@ */}
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">{fetchCreateNewUserLabel('CreateNewUser.Country')}</Form.Label>
                                                <Select
                                                    name="country"
                                                    id='userRoleCountry'
                                                    options={context.userRoleCountryList}
                                                    isMulti
                                                    value={userCountry}
                                                    aria-label="Role Country Select"
                                                    onChange={selected => {
                                                        selected.find(option => option.value === "all")
                                                            ? handleUserCountryChange(context.userRoleCountryList.slice(1)) :
                                                            handleUserCountryChange(selected);
                                                    }}

                                                />

                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="control-label">{fetchCreateNewUserLabel('CreateNewUser.ServiceOffice')}</Form.Label>
                                                <Select
                                                    name="serviceOffice"
                                                    options={userRoleServiceOfficeList || []}
                                                    isMulti
                                                    id="userRoleServiceOffice"
                                                    value={userRoleServiceOffice || []}
                                                    aria-label="Role Office Select"
                                                    onChange={selected => {
                                                        handleUserServiceOfficeChange(selected);
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                            {/* {fetchUserRole(userRole)} */}
                            {/* {(userRole && (userRole === "2d9917fe-7720-ed11-bd6e-501ac574d42d" || userRole === "2e9917fe-7720-ed11-bd6e-501ac574d42d")) && */}
                            {(userRole && (fetchUserRole(userRole) === COACH || fetchUserRole(userRole) === COACH_ADMIN)) &&
                                <>
                                    <Card.Body>
                                        <Card.Title>{fetchCreateNewUserLabel("CreateNewUser.UserProfileSection")}</Card.Title>
                                        <Form>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel("CreateNewUser.Bio")}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="bio"
                                                            id='bio'
                                                            placeholder={fetchCreateNewUserLabel('CreateNewUser.Bio')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.bio}
                                                            maxLength={3000}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel("CreateNewUser.Expertise")}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="expertise"
                                                            id='expertise'
                                                            placeholder={fetchCreateNewUserLabel('CreateNewUser.Expertise')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.expertise}
                                                            maxLength={500}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel("CreateNewUser.LinkedInID")}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="linkedInID"
                                                            id='linkedInID'
                                                            placeholder={fetchCreateNewUserLabel('CreateNewUser.LinkedInID')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.linkedInID}
                                                            maxLength={100}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.TwitterID')}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="twitterID"
                                                            id='twitterID'
                                                            placeholder={fetchCreateNewUserLabel('CreateNewUser.TwitterID')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.twitterID}
                                                            maxLength={100}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.Language')}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="language"
                                                            id='userRoleLanguage'
                                                            placeholder={fetchCreateNewUserLabel('CreateNewUser.Language')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.language}
                                                            maxLength={100}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                    <>
                                        <Card.Body>
                                            <Card.Title>{fetchCreateNewUserLabel("CreateNewUser.CronofySection")}</Card.Title>
                                            <Form>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.TimeZone")}</Form.Label>
                                                            <Form.Select
                                                                name="timeZone"
                                                                aria-label="Time Zone Select"
                                                                id="userRoleTimeZone"
                                                                onChange={e => { handleCronofyTime(e) }}
                                                            >
                                                                <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectTimeZone')}</option>
                                                                {cronofyTimeZone && cronofyTimeZone.length > 0 && cronofyTimeZone?.map((item) => (
                                                                    <option
                                                                        selected={allUserData?.ianaTimeZoneIdentifier == item?.ianaTimeZoneIdentifier}
                                                                        value={item?.ianaTimeZoneIdentifier}
                                                                    >
                                                                        {item?.ianaTimeZoneIdentifier}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.ServiceAccountName")}</Form.Label>
                                                            <Form.Select
                                                                aria-label="serviceAccountName Select"
                                                                id="serviceAccountName"
                                                                name="serviceAccountName"
                                                                onChange={(e) => handleCronofyServiceAccountName(e)}
                                                            >
                                                                <option>{fetchCreateNewUserLabel("CreateNewUser.SelectServiceAccountName")}</option>
                                                                {cronofyServiceAccount && cronofyServiceAccount.length > 0 && cronofyServiceAccount?.map((item) => (
                                                                    <option
                                                                        selected={allUserData?.serviceAccountId == item?.id}
                                                                        value={item?.id}
                                                                    >
                                                                        {item?.serviceAccountName}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.AvailableDay")}</Form.Label>
                                                            <Select
                                                                name="availableDay"
                                                                options={weekDaysList}
                                                                isMulti
                                                                id='availableDay'
                                                                value={workingHours.availableDays}
                                                                aria-label="Available Day Select"
                                                                onChange={selected => {
                                                                    selected.find(option => option.value === "all")
                                                                        ? handleWeekDaysChange(weekDaysList.slice(1)) :
                                                                        handleWeekDaysChange(selected);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.WorkingHoursStartTime")}</Form.Label>
                                                            <Form.Select
                                                                name="startTime"
                                                                aria-label="StartTime Select"
                                                                id="startTime"
                                                                onChange={e => {
                                                                    setStartTime(e.target.value);
                                                                }}
                                                            >
                                                                <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectWorkingHoursStarttime')}</option>
                                                                {hoursList && hoursList.length > 0 && hoursList?.map((item) => (
                                                                    <option
                                                                        selected={workingHours.startHour == item?.label}
                                                                        value={item?.label}
                                                                    >
                                                                        {item?.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.WorkingHoursEndTime")}</Form.Label>
                                                            <Form.Select
                                                                name="endTime"
                                                                aria-label="EndTime Select"
                                                                id="endTime"
                                                                onChange={e => {
                                                                    setEndTime(e.target.value);
                                                                }}
                                                            >
                                                                <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectWorkingHoursEndtime')}</option>
                                                                {hoursList && hoursList.length > 0 && hoursList?.map((item) => (
                                                                    <option
                                                                        selected={workingHours.endHour == item?.label}
                                                                        value={item?.label}
                                                                    >
                                                                        {item?.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </>
                                </>
                            }
                            <Card.Body>
                                <Form className="text-right">
                                    {alert?.showAlert &&
                                        <AlertMessage alertMessage={alert?.message} alertType={alert?.type} showAlert={showModal} />
                                    }
                                    <Button className="me-4" variant="primary" onClick={updateUserDetails}>{fetchCreateNewUserLabel("CreateNewUser.Save")}</Button>
                                    <Button variant="primary" onClick={deleteUserDetails}>{fetchCreateNewUserLabel("CreateNewUser.Cancel")}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Row>
                </Container>
            </Col>
        </React.Fragment>
    )
}
export default UserDetails;

